import { SignupError } from 'utils/errors/debuggableError';
import { useSignupDirectCtx } from '../context';
import { useEffectOnce } from 'react-use';
import { useCognitoUserContext } from 'domains/auth/AWSCognitoWrapper/context';
import { captureException } from '@sentry/react';
import { useNavigate } from 'react-router-dom';
import { routes } from 'router/routes';
import { LoadingDots } from '@expressable/syntax-ds';
import { useQueryClient } from 'react-query';

export const PostSignup = () => {
  const { loginContactInfo } = useSignupDirectCtx();

  const cognito = useCognitoUserContext();

  const navigate = useNavigate();

  if (!loginContactInfo) throw new SignupError('No login contact info on post signup route');

  const queryClient = useQueryClient();

  useEffectOnce(() => {
    const logic = async () => {
      queryClient.invalidateQueries(['contact']);
      queryClient.invalidateQueries(['contact-data']);
      if (loginContactInfo.isAlreadyContact) {
        if (!cognito.isLoggedIn) captureException(new SignupError('Expected existing contact to already be logged in'));
      } else {
        if (cognito.isLoggedIn) {
          cognito.signOut();
        }

        if (!cognito.isLoggedIn) {
          await cognito.logIn(loginContactInfo.email, loginContactInfo.newPassword);
        }
      }

      navigate(routes.root, {
        replace: true,
      });
    };

    logic();
  });

  return (
    <div className="w-full h-full grow flex items-center">
      <LoadingDots message="Almost ready..." className="static " />
    </div>
  );
};
